

    angular.module('qkr').controller("unknownBeneficiaryEmailConfigController",
                                        UnknownBeneficiaryEmailConfigController);

    UnknownBeneficiaryEmailConfigController.$inject = ['$uibModalInstance', 'messageService', 'lookupDataUploadService',
                                                    'reportService', 'data', 'gettextCatalog'];

    function UnknownBeneficiaryEmailConfigController ($uibModalInstance, messageService, lookupDataUploadService,
                                                      reportService, data, gettextCatalog) {

        const vm = this;
        vm.hours = reportService.getHours();
        vm.minutes = reportService.getMinutes();
        vm.form = data;

        vm.cancel = () => {
            $uibModalInstance.dismiss('cancel');
        };

        const successHandler = () => {
            $uibModalInstance.close("Saved");
            messageService.success(gettextCatalog.getString("Email details saved."));
        }

        const errorHandler = () => {
            messageService.error(gettextCatalog.getString("Update failed"));
        }

        vm.save = () => {
            if (!validate()) {
                return;
            }
            lookupDataUploadService.saveUnknownLookupBeneficiaryEmailConfig(vm.form)
                .then(successHandler, errorHandler);
        };

        function validate() {
            vm.errors = null;
            let valid = true;
            const errors = {};

            if (!(/^[A-Za-z0-9._%+-]*[A-Za-z0-9]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(vm.form.email))) {
                errors.email = gettextCatalog.getString('A valid email must be entered');
                valid = false;
            }

            vm.errors = errors;

            return valid;
        }
    }




// WEBPACK FOOTER //
// ./src/controllers/unknownBeneficiary.email.config.controller.js